import * as Yup from "yup";

export const schemaChildrenNames = Yup.object().shape({
  childrenFirstName: Yup.string()
    .min(3, "First name must be longer than 3 characters")
    .required("First name is a required field"),
  childrenLastName: Yup.string()
    .min(3, "Last name must be longer than 3 characters")
    .required("Last name is a required field"),
  idSelected: Yup.string().required("You need to select a plan"),
});
